<style scoped lang="scss">
@import '../assets/style/_mixin.scss';

$input-padding-x: .75rem;
$input-padding-y: .75rem;

.form-signin {
  width: 100%;
  max-width: 330px;
  padding: 15px;
  margin: auto;
}

.form-label-group {
  margin-bottom: 1rem;
  position: relative;
  text-align: left;
}

.form-label-group > input,
.form-label-group > label {
  padding: $input-padding-y $input-padding-x;
}

.form-label-group > label {
  position: absolute;
  top: 0;
  left: 0;
  display: block;
  width: 100%;
  margin-bottom: 0; /* Override default `<label>` margin */
  line-height: 1.5;
  color: #495057;
  border: 1px solid transparent;
  border-radius: .25rem;
  transition: all .1s ease-in-out;
}

.form-label-group input::-webkit-input-placeholder {
  color: transparent;
}

.form-label-group input:-ms-input-placeholder {
  color: transparent;
}

.form-label-group input::-ms-input-placeholder {
  color: transparent;
}

.form-label-group input::-moz-placeholder {
  color: transparent;
}

.form-label-group input::placeholder {
  color: transparent;
}

.form-label-group input:not(:placeholder-shown) {
  padding-top: $input-padding-y + $input-padding-y * (2 / 3);
  padding-bottom: $input-padding-y / 3;
}

.form-label-group input:not(:placeholder-shown) ~ label {
  padding-top: $input-padding-y / 3;
  padding-bottom: $input-padding-y / 3;
  font-size: 12px;
  color: #777;
}
</style>

<template>
  <div class="form-label-group">
    <!-- <input
      class="form-control"
      :type="type"
      :id="id"
      :value="value"
      :placeholder="placeholder"
      :required="required"
      :autofocus="autofocus"
      @input="$emit('update:value', $event.target.value)"
      @keyup.enter="keyupEnterCallback"
    > -->
    <input
      :type="type"
      :id="id"
      :name="name"
      :value="value"
      v-validate="rule"
      :class="{ 'form-control': true, [`form-control-${size}`]: true, 'border-danger': errors.has(name) }"
      :placeholder="placeholder"
      :required="required"
      :autofocus="autofocus"
      @input="$emit('update:value', $event.target.value)"
      @keyup.enter="keyupEnterCallback"
    />
    <small v-show="errors.has(name)" class="d-block text-danger text-right">
      <font-awesome-icon :icon="faExclamationCircle" v-show="errors.has(name)" />
      {{ errors.first(name) }}
    </small>
    <label :for="id">{{ placeholder }}</label>
  </div>
</template>

<script>
import FontAwesomeIcon from '@fortawesome/vue-fontawesome'
import { faExclamationCircle } from '@fortawesome/fontawesome-free-solid'

export default {
  components: {
    FontAwesomeIcon
  },
  /**
   * To control the errorBag on parent component,
   * please remember to add provide() to parent.
   * e.g.
   *  provide () {
   *    return {
   *      parentValidator: this.$validator
   *    }
   *  }
   */
  inject: {
    parentValidator: {
      default: null
    }
  },
  created () {
    if (this.parentValidator != null) {
      this.$validator = this.parentValidator
    }
  },
  props: {
    type: {
      type: String,
      default: 'text'
    },
    id: {
      type: String
      // default: _.
    },
    name: {
      type: String,
      default: 'text',
      required: true
    },
    value: {
      type: [String, Number]
    },
    rule: {
      type: [String, Object],
      default: 'required|alpha_num'
    },
    size: {
      type: String,
      default: 'sm'
    },
    placeholder: {
      type: String,
      default: 'Input Title'
    },
    required: {
      type: Boolean,
      default: false
    },
    autofocus: {
      type: Boolean,
      default: false
    },
    keyupEnterCallback: {
      type: Function,
      default: () => {}
    }
  },
  data () {
    return {
      faExclamationCircle
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/InputFloatLabel.vue